
export default (store) => ({
  path: 'finish',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Finish = require('./components/Finish').default

      /*  Return getComponent   */
      cb(null, Finish)

    /* Webpack named bundle   */
    }, 'Finish')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/DecisionTool/routes/Finish/index.js
 **/